__turbopack_context__.v({
  "className": "poppins_12cc83c9-module__dbHZna__className",
});
